import { studioDeleteModalText } from 'Const/studio/text';
import useDeleteStudio from 'Domain/studio/useDeleteStudio';
import { useModal } from 'Store/modal';

const useOpenDeleteModal = () => {
  const { onOpenModal } = useModal();

  const { mutate: onDeleteStudio } = useDeleteStudio();

  const onOpenDeleteModal = (id) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: studioDeleteModalText.title,
      contentDescription: studioDeleteModalText.description,
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: studioDeleteModalText.submitButton,
      secondaryButtonText: studioDeleteModalText.closeButton,
      onClickPrimaryButton: () => onDeleteStudio(id),
    });
  };

  return { onOpenDeleteModal };
};

export default useOpenDeleteModal;
